document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("raataiLeadModal");
  const closeBtn = document.querySelector(".raatai-close");
  const form = document.getElementById("raataiLeadForm");
  const fieldsContainer = document.getElementById("zeedoneCustomFields");
  const loader = document.getElementById("zeedoneLoader");

  function formatLabel(text) {
  return text
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, char => char.toUpperCase());
}

const ALLOWED_FIELDS = [
  "name",
  "email",
  "phone",
  "where-did-you-hear-about-us"
];


  /* ================================
     LOAD ZEEDONE CUSTOM FIELDS
  ================================= */
  async function loadZeedOneCustomFields() {
    loader.style.display = "block";
    fieldsContainer.innerHTML = "";

    try {
      const response = await fetch(
        "https://app.zeedone.com/api/v1/lead-customfields",
        {
          headers: {
            "Authorization": "Bearer 26|6CJhNvOZh6nOTzanLhLt8sZUugR54YUASqz3ueNd",
            "Accept": "application/json"
          }
        }
      );

      const data = await response.json();
      const fields = data.message;

      loader.style.display = "none";

     fields.forEach(field => {
  const fieldName = field.name.toLowerCase();

  // 🚫 Skip fields that are not allowed
  if (!ALLOWED_FIELDS.includes(fieldName)) return;

  const wrapper = document.createElement("div");
  wrapper.className = "zeedone-field-wrapper";

  const label = document.createElement("label");
  label.textContent = formatLabel(field.name);

  const input = document.createElement("input");
  input.type = "text";
  input.dataset.fieldId = field.id;
  input.required = true;
  input.className = "zeedone-field";

  wrapper.appendChild(label);
  wrapper.appendChild(input);
  fieldsContainer.appendChild(wrapper);
});

    } catch (error) {
      loader.textContent = "Failed to load form fields";
      console.error("Error loading ZeedOne fields:", error);
    }
  }

  /* ================================
     OPEN MODAL AFTER 2 SECONDS
  ================================= */
  if (
   !localStorage.getItem("raataiLeadSubmitted")
  ) {
    setTimeout(() => {
      modal.style.display = "block";
      loadZeedOneCustomFields();
    }, 2000);
  }

  /* ================================
     CLOSE MODAL
  ================================= */
  closeBtn.addEventListener("click", () => {
    localStorage.setItem("raataiLeadSubmitted", "true");
    modal.style.display = "none";
  });

  window.addEventListener("click", e => {
    if (e.target === modal) modal.style.display = "none";
  });

  /* ================================
     SUBMIT LEAD
  ================================= */
 form.addEventListener("submit", async e => {
  e.preventDefault();

  const submitBtn = document.getElementById("raataiSubmitBtn");
  const messageBox = document.getElementById("raataiFormMessage");

  submitBtn.classList.add("loading");
  submitBtn.disabled = true;
  messageBox.style.display = "none";

  const params = new URLSearchParams();
  let clientName = "";
  let clientEmail = "";

  document.querySelectorAll(".zeedone-field").forEach(input => {
    const label =
      input.previousElementSibling?.textContent?.toLowerCase() || "";
    const value = input.value;
    const fieldId = input.dataset.fieldId;

    if (label === "name") clientName = value;
    if (label === "email") clientEmail = value;

    params.append(`custom_fields_data[key_${fieldId}]`, value);
  });

  if (!clientName || !clientEmail) {
    showMessage("Please fill all required fields.", "error");
    resetButton();
    return;
  }

  params.append("client_name", clientName);
  params.append("client_email", clientEmail);
  params.append("source_id", "256");
  params.append("next_follow_up", "no");

  try {
    const response = await fetch(
      "https://app.zeedone.com/api/v1/lead",
      {
        method: "POST",
        headers: {
          "Authorization": "Bearer 26|6CJhNvOZh6nOTzanLhLt8sZUugR54YUASqz3ueNd",
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: params.toString()
      }
    );

    if (response.ok) {
      localStorage.setItem("raataiLeadSubmitted", "true");
      showMessage("Thanks! Our team will contact you shortly 😊", "success");

      setTimeout(() => {
        modal.style.display = "none";
        form.reset();
      }, 1800);
    } else {
      const errorData = await response.json();

  let errorMessage = "Something went wrong.";

  if (
    errorData?.error?.details
  ) {
    const details = errorData.error.details;

    // Get first error message dynamically
    const firstKey = Object.keys(details)[0];
    errorMessage = details[firstKey][0];
  }

  showMessage(errorMessage, "error");
    }
  } catch (error) {
    showMessage("Network error. Please try again later.", "error");
  } finally {
    resetButton();
  }

  function resetButton() {
    submitBtn.classList.remove("loading");
    submitBtn.disabled = false;
  }

  function showMessage(text, type) {
    messageBox.textContent = text;
    messageBox.className = `raatai-form-message ${type}`;
    messageBox.style.display = "block";
  }
});


});
